import http from './httpService';

export function getAllMetodologies() {
  return http.get(`/methodologies`);
}

export function createMetodology(payload) {
  return http.post(`/methodologies`, payload);
}

export function updateMetodology(payload) {
  return http.put(`/methodologies`, payload);
}

export function deleteMetodology(id) {
  return http.delete(`/methodologies/${id}`);
}
